import { MobileNavigation } from './MobileNavigation';
import { useEffect, useRef, type ReactNode } from 'react';
import { serverTabs, type ServerTab } from '../pages/server-navigation';

export function ServerTabs({ tab, onChange }: { tab: ServerTab; onChange: (tab: ServerTab) => void }) {
  const list = useRef<HTMLDivElement>(null);
  useEffect(() => {
    list.current?.querySelector('[aria-selected="true"]')?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
  }, [tab]);
  return (
    <MobileNavigation title="サーバーのメニュー" inline>
      <div ref={list} className="tabs" role="tablist" aria-label="サーバー詳細">
        {serverTabs.map((item, index) => (
          <button
            key={item.id}
            id={`server-tab-${item.id}`}
            role="tab"
            aria-controls="server-panel"
            aria-selected={tab === item.id}
            tabIndex={tab === item.id ? 0 : -1}
            className={`tab${tab === item.id ? ' active' : ''}`}
            onClick={() => onChange(item.id)}
            onKeyDown={(event) => {
              const next = {
                ArrowRight: (index + 1) % serverTabs.length,
                ArrowLeft: (index + serverTabs.length - 1) % serverTabs.length,
                Home: 0,
                End: serverTabs.length - 1,
              }[event.key];
              if (next === undefined) return;
              event.preventDefault();
              onChange(serverTabs[next]!.id);
              list.current?.querySelectorAll<HTMLButtonElement>('[role="tab"]')[next]?.focus();
            }}
          >
            {item.label}
          </button>
        ))}
      </div>
    </MobileNavigation>
  );
}

export function ServerSections({
  sections,
  section,
  onChange,
  children,
  title = '設定の節',
  heading = true,
}: {
  sections: { id: string; label: string }[];
  section: string;
  onChange: (section: string) => void;
  children: ReactNode;
  /** 狭い画面で開くメニューの見出し */
  title?: string;
  /** 節の名前を見出しとして出すか（中のカードに見出しがあるときは出さない） */
  heading?: boolean;
}) {
  const list = useRef<HTMLElement>(null);
  useEffect(() => {
    list.current?.querySelector('[aria-current="page"]')?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
  }, [section]);
  return (
    <div className="section-layout">
      <MobileNavigation title={title} inline>
        <nav ref={list} className="section-nav" aria-label="節">
          {sections.map((item) => (
            <button
              key={item.id}
              className={`nav-link${section === item.id ? ' active' : ''}`}
              aria-current={section === item.id ? 'page' : undefined}
              onClick={() => onChange(item.id)}
            >
              {item.label}
            </button>
          ))}
        </nav>
      </MobileNavigation>
      <section
        data-search-id={section === 'schedule' || section === 'software' ? section : undefined}
        data-search-section={section}
        className="stack section-content"
        aria-label={sections.find((item) => item.id === section)?.label}
      >
        {heading && <h2>{sections.find((item) => item.id === section)?.label}</h2>}
        {children}
      </section>
    </div>
  );
}
